import { UnwrapHelper } from '../UnwrapHelper';
export class UnwrapBooleanHelper extends UnwrapHelper {
}

//# sourceMappingURL=UnwrapBooleanHelper.js.map
